/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface RequiredCapabilityProps {
  id: string;
}

export class RequiredCapabilityRecord extends Record<RequiredCapabilityProps>({
  id: null as any,
}) {
  public static fromJS(json: { id: string }): RequiredCapabilityRecord {
    if (json == null) {
      throw new Error('RequiredCapabilityRecord.fromJS: parameter cannot be null');
    }
    return new RequiredCapabilityRecord({
      id: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
        'RequiredCapabilityJson.id',
      ),
    });
  }

  public static fromJSUnsafe(json: { id: string }): [RequiredCapabilityRecord, Error[]] {
    if (json == null) {
      throw new Error('RequiredCapabilityRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new RequiredCapabilityRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
            'RequiredCapabilityJson.id',
          ),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: RequiredCapabilityProps) {
    super(props);
    if (props == null) {
      throw new Error('RequiredCapabilityRecord constructor parameter cannot be null');
    }
  }
}

export abstract class RequiredCapabilityViewModelBase implements RequiredCapabilityProps {
  protected readonly _props: RequiredCapabilityProps;
  private _json?: RequiredCapabilityProps;

  get id(): string {
    return this._props.id;
  }

  constructor(props: RequiredCapabilityProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        id: this._props.id,
      };
    }
    return this._json;
  }
}
